<!--Navbar Start-->
<nav class="navbar navbar-expand-lg fixed-top navbar-custom sticky sticky-dark" (window:scroll)="windowScroll()"
  id="navbar">
  <div class="container">
    <!-- LOGO -->
    <a class="navbar-brand logo" routerLink="/home">
      <img
        [src]="(useWhiteLogo === true && isSmartPhone === false) ? '/assets/images/BEMDDOPS LOGO WHITE.svg' : '/assets/images/BEMDDOPS LOGO DARK.svg'"
        alt="" class="" height="50">
    </a>
    <button class="navbar-toggler p-0" type="button" data-toggle="collapse" data-target="#navbarCollapse"
      aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation" (click)="toggleMenu()">
      <i class="mdi mdi-menu"></i>
    </button>
    <div class="collapse navbar-collapse" id="navbarCollapse">
      <ul class="navbar-nav ml-auto navbar-center" id="mySidenav">
        <li class="nav-item" [ngClass]="{'active':onLandingPage}">
          <a [ngxScrollTo]="'#home'" routerLink="/home" class="nav-link">Home</a>
        </li>
        <li class="nav-item" [ngClass]="{'active':onServicesPage}">
          <a [ngxScrollTo]="'#services'" routerLink="/services" class="nav-link" [ngxScrollToOffset]="2">Services</a>
        </li>
        <li class="nav-item">
          <a [ngxScrollTo]="'#our-blog'" href="https://www.bemddops.blog/" class="nav-link"
            [ngxScrollToOffset]="2">Blog</a>
        </li>
        <li class="nav-item contact-us">
          <a routerLink="/contact-us" routerLink="/contact-us" class="nav-link">Contact
            Us</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
<!-- Navbar End -->
